import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { LoadingPage } from 'Pages/Shared/LoadingPage';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { ROUTE } from 'Services/Route/Route.types';

export const AuthCallbackPage = () => {
    const { logout } = useAuth0();
	const navigate = useNavigate();

    const { getAccessTokenSilently, isAuthenticated, isLoading } = useAuth0();
	const [isFetching, setFetching] = useState(true);

	useEffect(() => {
		if (isAuthenticated && !isLoading) {
			getAccessTokenSilently().then((data:any) => {
				localStorage.setItem(window.btoa('accessToken'), window.btoa(data));
			});
		
			navigate(ROUTE.DASHBOARD);
			return;
		} else {
			setFetching(false);
		}
	}, [isAuthenticated]);

    return (isLoading || isFetching) ? <LoadingPage />: (
		<>
            <Helmet>
                <title>Auth - Growing People</title>
            </Helmet>

			<h1>Unauthorized</h1>

            <div className="primarybutton w-inline-block" onClick={() => logout({
				returnTo: window.location.origin
			})}>
                <div>Try a different email</div>
            </div>
        </>
	)
}